import { Row, Col } from "react-bootstrap";
import "./CVimage.css";
import { images } from "../../../../../constants/index";
import ProfileInformationCV from "../profileInformation3";
import CVProfileBio from "../CVProfileBio3";
import { getAsset } from "../../../../../helpers/helper";
import dummyezi from "../../../../../assets/images/dummy/dummyezi.png";

const CVImage = ({ cvdata }) => {
  return (

    <Row>
      <Col md={4} lg={4} xl={4} >
        <div className="name-back">
          <div className=" pt-2 p-3 d-flex flex-column align-items-center">
            <Col md={12} lg={12} className=" p-0">
              <div className="img-3-Background">
                <img
                  src={getAsset(cvdata?.profileInformation?.photo || cvdata?.user?.imageUrl)}
                  onError={(e) => { e.target.onerror = null; e.target.src = dummyezi; }}
                  crossOrigin="anonymous"
                  alt=""
                  className="img-5-Background " />
              </div>
            </Col>

            <div className="profile-4-scroll noscroll ps-md-2 ps-lg-2 ps-xl-0">
              <ProfileInformationCV cvdata={cvdata} />
            </div>
          </div>
        </div>
      </Col>
      <Col md={8} lg={8} xl={8} className="pe-0 ps-0">
        <CVProfileBio cvdata={cvdata} />
      </Col>
    </Row>

  );
};
export default CVImage;
